import {createFileRoute} from '@tanstack/react-router';

import {VehiclesPage} from '@/modules/admin-settings/pages/VehiclesPage';

export const Route = createFileRoute('/_authenticated/admin/settings/vehicles/')({
  component: VehiclesPage,
});
